import { utils, writeFile } from "xlsx";
import { ITableColumn } from "@interfaces/common.interfaces";

const EXCEL_CELL_LIMIT = 32767;
const TRUNCATION_SUFFIX = "…[truncated]";

export function downloadAsXlsx(
    columns: Array<ITableColumn<any>>,
    items: ReadonlyArray<any>,
    filenamePrefix: string,
): { truncatedCells: number } {
    const exportable = columns.filter(c => c.showInExport !== false);
    let truncatedCells = 0;

    const clamp = (v: string): string => {
        if (v.length <= EXCEL_CELL_LIMIT) return v;
        truncatedCells++;
        return v.substring(0, EXCEL_CELL_LIMIT - TRUNCATION_SUFFIX.length) + TRUNCATION_SUFFIX;
    };

    const headerRow = exportable.map(c => clamp(String(c.label)));
    const dataRows = items.map(item =>
        exportable.map(col => {
            const raw = col.getExportValue
                ? col.getExportValue(col.key, item)
                : ((item as any)[col.key] ?? "");
            return clamp(String(raw));
        })
    );

    const wb = utils.book_new();
    const ws = utils.aoa_to_sheet([headerRow, ...dataRows]);
    utils.book_append_sheet(wb, ws, "Report");
    writeFile(wb, `${filenamePrefix}.xlsx`);

    return { truncatedCells };
}
